export var directions = ['row', 'column', 'row-reverse', 'column-reverse'];
export var alignItems = ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'];
export var justifyContent = [
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly'
];
export var wraps = ['nowrap', 'wrap', 'wrap-reverse'];
//# sourceMappingURL=types.js.map